if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('.product-sticky-bar__button');
        this.priceEl = this.querySelector('.product-sticky-bar__price');
        this.label = this.querySelector('.product-sticky-bar__label');
        this.source = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);

        this.setHeight();
        this.resizeObserver = new ResizeObserver(() => this.setHeight());
        this.resizeObserver.observe(this);

        // Troca de variante: copia o preço da section re-renderizada pelo product-info.js.
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.sectionId) return;
          const price = data.html.getElementById(`StickyBarPrice-${this.sectionId}`);
          if (price) this.priceEl.innerHTML = price.innerHTML;
        });

        // Espelha o estado do botão original (esgotado, carregando) na barra.
        if (this.source) {
          this.syncButton();
          this.mutationObserver = new MutationObserver(() => this.syncButton());
          this.mutationObserver.observe(this.source, { attributes: true });
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.unsubscribe?.();
        document.documentElement.style.removeProperty('--product-sticky-bar-height');
      }

      setHeight() {
        document.documentElement.style.setProperty('--product-sticky-bar-height', `${this.offsetHeight}px`);
      }

      syncButton() {
        const soldOut = this.source.hasAttribute('disabled');
        const busy = this.source.getAttribute('aria-disabled') === 'true';
        this.button.disabled = soldOut;
        this.button.setAttribute('aria-disabled', soldOut || busy ? 'true' : 'false');
        this.button.classList.toggle('loading', busy);
        this.label.textContent = soldOut ? window.variantStrings.soldOut : this.dataset.addLabel || this.label.textContent;
      }
    }
  );
}
